import { ReactNode } from 'react';
import { cn } from '@zep/utils';
import S from './PlanSpaceGroup.module.scss';
export const PlanSpaceGroup = (props: SubscribedSpaceGroupProps) => {
  const {
    title,
    className,
    children
  } = props;
  return <div className={cn(S.group, className)} data-sentry-component="PlanSpaceGroup" data-sentry-source-file="PlanSpaceGroup.tsx">
      <div className={cn(S.column, S.title)}>
        {title && <h3 className={S.title}>{title}</h3>}
      </div>
      <div className={cn(S.column, S.content)}>{children}</div>
    </div>;
};
type SubscribedSpaceGroupProps = {
  title?: string;
  className?: string;
  children: ReactNode;
};